/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CalendarScheduleAppointment/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CalendarScheduleAppointment({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CalendarScheduleAppointment",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CalendarScheduleAppointment.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-1OlqYG': alignSelf,'--mt-2-1OlqYG': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1OlqYG': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1OlqYG': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1OlqYG': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1OlqYG': opacity,'--w-10-1OlqYG': typeof width === 'number' ? `${width}px` : width,'--h-11-1OlqYG': typeof height === 'number' ? `${height}px` : height,'--f-12-1OlqYG': fill,'--a-7-1OlqYG': isAnimated ? animation : "none",'--sd-8-1OlqYG': isAnimated ? strokeDashoffset : 0,'--sd-9-1OlqYG': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2CalendarScheduleAppointment.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_5041_2264)"
 className="views-block"
>
<path
  data-testid="Tysiav2CalendarScheduleAppointment.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M6.646.146A.5.5 0 017 0a7 7 0 017 7 .5.5 0 01-.5.5H7a.5.5 0 01-.5-.5V.5a.5.5 0 01.146-.354zM7.75 12.25a.75.75 0 00-1.5 0v1a.75.75 0 001.5 0v-1zM0 7a.75.75 0 01.75-.75h1a.75.75 0 010 1.5h-1A.75.75 0 010 7zm3.11-4.95a.75.75 0 10-1.06 1.06l.86.862A.75.75 0 003.973 2.91l-.861-.86zm6.918 7.978a.75.75 0 011.061 0l.86.86a.75.75 0 01-1.06 1.062l-.86-.861a.75.75 0 010-1.06zm-6.056 1.06a.75.75 0 10-1.061-1.06l-.86.86a.75.75 0 001.06 1.062l.86-.861z"
 style={{'--f-12-1OlqYG': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}